import { IconWrapper } from '../runtime';
export default IconWrapper('audio_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#5F6A72"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#8999A3"
    }
  }), h("path", {
    "attrs": {
      "d": "M12.0006 8.75903V2.25L4.50058 4.25V8.98681C4.38712 8.99852 4.27154 9.01962 4.15544 9.05073C3.30189 9.27944 2.74321 9.96217 2.9076 10.5757C3.07198 11.1891 3.89718 11.5011 4.75072 11.2724C5.58806 11.048 6.14162 10.3867 6.00714 9.78245L6.00839 5.45L10.5006 4.25V7.99072C10.3871 8.00242 10.2715 8.02353 10.1554 8.05464C9.30189 8.28335 8.74321 8.96608 8.9076 9.57956C9.07198 10.1931 9.89718 10.505 10.7507 10.2763C11.6007 10.0485 12.1583 9.37052 12.0006 8.75903Z",
      "fill": "white"
    }
  })]);
});